export default __webpack_public_path__ + "static/speed-ba906fe1851de0820f69cd06a69b8c76.png";